
<router-outlet></router-outlet>

<!--     for httpRequest loader    -->
<ngx-ui-loader></ngx-ui-loader>
